import styled from 'styled-components'

export const ButtonWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`

export const ListWrapper = styled.div`
  margin-top: 50px;
`
